import { ServiceData } from '@/types';

import articles from './PILATES_ARTICLES_RO.json';
import exercises from './PILATES_EXERCISES_RO.json';
import recipes from './PILATES_RECIPES_RO.json';

export const PILATES_DATA_RO: ServiceData = {
  articles,
  exercises,
  recipes,
};
